import imgFacebook from '@/assets/img/rs/facebook.svg'
import imgInstagram from '@/assets/img/rs/instagram.svg'
import imgLinkedIn from '@/assets/img/rs/linkedin.svg'
import imgSnapchat from '@/assets/img/rs/snapchat.svg'
import imgTiktok from '@/assets/img/rs/tiktok.svg'
import imgWhatsapp from '@/assets/img/rs/whatsapp.svg'
import imgX from '@/assets/img/rs/x.svg'
import imgYoutube from '@/assets/img/rs/youtube.svg'
import imgCalameo from '@/assets/img/rs/calameo.svg'
import logoInstagram from '@/assets/img/rs/l-instagram.png'
import logoFacebook from '@/assets/img/rs/l-facebook.png'
import logoLinkedIn from '@/assets/img/rs/l-linkedin.png'
import logoSnapchat from '@/assets/img/rs/l-snapchat.png'
import logoX from '@/assets/img/rs/l-x.png'
import logoYoutube from '@/assets/img/rs/l-youtube.png'
import logoTiktok from '@/assets/img/rs/l-tiktok.png'
import logoWhatsapp from '@/assets/img/rs/l-whatsapp.png'
import logoCalameo from '@/assets/img/rs/l-calameo.png'

export const socialNetworks = {
    facebook: {
        name: 'Facebook',
        image: imgFacebook.src,
        logo: logoFacebook.src
    },
    instagram: {
        name: 'Instagram',
        image: imgInstagram.src,
        logo: logoInstagram.src
    },
    /*x: {
        name: 'X',
        image: imgX.src,
        logo: logoX.src
    },*/
    linkedin: {
        name: 'LinkedIn',
        image: imgLinkedIn.src,
        logo: logoLinkedIn.src
    },
    youtube: {
        name: 'Youtube',
        image: imgYoutube.src,
        logo: logoYoutube.src
    },
    tiktok: {
        name: 'Tiktok',
        image: imgTiktok.src,
        logo: logoTiktok.src
    },
    snapchat: {
        name: 'SnapChat',
        image: imgSnapchat.src,
        logo: logoSnapchat.src
    },
    whatsapp: {
        name: 'WhatsApp',
        image: imgWhatsapp.src,
        logo: logoWhatsapp.src
    },
    calameo: {
        name: 'Calameo',
        image: imgCalameo.src,
        logo: logoCalameo.src
    }
}